import { SubAccount } from "../../../../../Wrap/Models/Domains/Account/SlAccounts/SubAccount";
import { CappedArrangementDetails } from "../../../../../Wrap/Models/Domains/Drawdown/CappedArrangementDetails";
import { MenuItem } from "../../../../../Wrap/Models/Domains/Menu/MenuItem";
import { PensionSubAccountSettings } from "../../../../../Wrap/Models/Domains/SubAccount/PensionSubAccountSettings";
import { Contents } from "../../../Resoures/Contents";
import { IParameterModel } from "../IParameterModel";

export class MenuItemsHelper {
    public static getConditionalMenuItems(
        pensionSubAccountSettings: PensionSubAccountSettings,
        cappedArrangementDetails: Array<CappedArrangementDetails>,
        queryParameter: IParameterModel,
        nprSubAccount: SubAccount
    ) {
        const menuItems: MenuItem[] = [];
        if (pensionSubAccountSettings) {
            if (pensionSubAccountSettings.CanEditRegularCrystallisation) {
                //TODO : add permission check when build pension permission
                menuItems.push({ MenuCaption: "Edit income drawdown", Url: "", SubMenu: null });
            }
            if (pensionSubAccountSettings.CanEditIncome) {
                //TODO : add permission check when build pension permission
                menuItems.push({ MenuCaption: "Edit income payments", Url: "", SubMenu: null });
            }
            if (pensionSubAccountSettings.CanEditRegularCrystallisation) {
                //TODO : add permission check when build pension permission
                menuItems.push({
                    MenuCaption: "Cancel regular crystallisation",
                    Url: `/wpadviser/en-gb/dashboard/home/main/client/cancel-regular-crystallisation/review?&claccountid=${queryParameter.clAccountId}&hierarchyid=${queryParameter.hierarchyId}&subaccounthierarchyid=${nprSubAccount.HierarchyId}`,
                    SubMenu: null,
                });
            }
            if (
                pensionSubAccountSettings.GadReviewEnabled &&
                cappedArrangementDetails != null &&
                cappedArrangementDetails.length > 0
            ) {
                //TODO : add permission check when build pension permission
                cappedArrangementDetails.forEach((arrangement) => {
                    menuItems.push({
                        MenuCaption: `GAD review (${arrangement.ArrangementId})`,
                        Url: `/wpadviser/en-gb/dashboard/home/main/client/gad-review/income-payment?claccountid=${queryParameter.clAccountId}&hierarchyid=${queryParameter.hierarchyId}&subaccounthierarchyid=${nprSubAccount.HierarchyId}&arrangementid=${arrangement.ArrangementId}`,
                        SubMenu: null,
                    });
                });
            }
            //TODO : add permission check when build pension permission
            menuItems.push({
                MenuCaption: "Update LTA",
                Url: `/wpadviser/en-gb/dashboard/home/main/client/update-lifetime-allowance/update-lifetime-allowance-detail?hierarchyid=${queryParameter.hierarchyId}`,
                SubMenu: null,
            });
            if (pensionSubAccountSettings.CanConvertToFlexi) {
                //TODO : add permission check when build pension permission
                menuItems.push({
                    MenuCaption: "Convert capped to flexi",
                    Url: `/wpadviser/en-gb/dashboard/home/main/client/convert-capped-to-flexi/select-arrangement?hierarchyid=${queryParameter.hierarchyId}&claccountid=${queryParameter.clAccountId}`,
                    SubMenu: null,
                });
            }
            if (pensionSubAccountSettings.CanEditIncome) {
                //TODO : add permission check when build pension permission
                menuItems.push({ MenuCaption: "One-off income payment", Url: "", SubMenu: null });
                menuItems.push({
                    MenuCaption: "Edit income payment",
                    Url: `/wpadviser/en-gb/dashboard/home/main/${Contents.URLMap.client}/${Contents.URLMap.editIncomeWithdrawals}/${Contents.URLMap.incomePayment}?claccountid=${queryParameter.clAccountId}&hierarchyid=${queryParameter.hierarchyId}&subaccounthierarchyid=${nprSubAccount.HierarchyId}`,
                    SubMenu: null,
                });
            }
        }
        return menuItems;
    }
}
